var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-4.32527e-07 0.104933L-3.8939e-07 1.09179C-3.86457e-07 1.1589 0.0292966 1.22206 0.0773434 1.26153L4.66641 4.99975L0.0773438 8.73797C0.0292969 8.77744 -5.06788e-08 8.8406 -4.77455e-08 8.90771L-4.60856e-09 9.89457C-8.70024e-10 9.9801 0.0867189 10.0301 0.148828 9.9801L5.84531 5.34055C6.05156 5.17212 6.05156 4.82738 5.84531 4.66027L0.148828 0.0207205C0.0867184 -0.0305958 -4.36266e-07 0.0194054 -4.32527e-07 0.104933Z"}));
}

ArrowRightInline.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
